export default {
  // Tooltip content
  aiModel: "AI Model",
  dataUpdate: "Data Update",
  canvasFilter: "Canvas Filter",
  historyRecord: "History Record",
  investigation: "Investigation",
  sameIpTime: "Same IP Time",

  // Data update panel
  dataUpdateTitle: "Data Update",
  updateInstruction: "Click the refresh button on the right to update",
  investigationData: "Investigation Data",
  labelRemarks: "Label Remarks",
  addressBalance: "Address Balance",
  lastUpdate: "Last update: {time}",

  // Balance update dialog
  balanceDialogTitle: "Notice",
  balanceDialogContent:
    "There are {count} addresses in the current canvas. Updating balances will take a long time, please be patient!",
  cancel: "Cancel",
  confirm: "Confirm",

  // Message prompts
  queryingBalance: "Querying balance, please wait",
  queryingData: "Querying data, please wait",
  queryingLabels: "Querying labels, please wait",
  updateSuccess: "Update successful",

  // Configuration confirmation dialog
  configConfirmTitle: "Notice",
  configConfirmMessage: "Do you want to modify the current configuration?",
  confirmButton: "Confirm",
  cancelButton: "Cancel",
  configUpdateSuccess: "Configuration updated successfully!",
  configUpdateCanceled: "Modification canceled",

  // Others
  investigationDetails: "Investigation Details",
};
